import React from 'react'
import Translation from "../../../components/common/translation/translation.component";
const LineChartToolTip = ({ active, payload, label, invoiceMonth }) => {
    if (invoiceMonth.some(item => item.InvoiceMonth === payload[0]?.payload?.Month)) {
        return (
            <div className="custom-line-chart-tooltip">
                <p className="label">{`${label}`}</p>
                <p className="net-amount">{`Net Amount: ${payload[0]?.payload?.TotalNetAmount}`}</p>
                <p className="gross-amount">{`Gross Amount: ${payload[0]?.payload?.TotalGrossAmount}`}</p>
            </div>
        );
    }
    else {
        return (
            <div className="custom-line-chart-tooltip">
                <p className="label"><Translation translationKey={"tooltip_no_invoice"} /></p>
            </div>
        );
       
    }
  };

  export default LineChartToolTip;